export default __webpack_public_path__ + "6116ecad11ad1ec9e414cf075c7f3b83.png";